<template>
  <div>
    <Header title=" " :isBack="false" :isHistory="false"></Header>
    <div class="notFound">
      <dl>
        <dt>페이지를 찾을 수 없습니다.</dt>
        <dd>
          페이지가 존재하지 않거나, 사용할 수 없는 페이지입니다.<br />
          입력하신 주소가 정확한지 다시 한 번 확인해주세요.
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header';
import { mapGetters } from 'vuex';
export default {
  name: 'NotFound',
  components: {
    Header
  },
  computed: {
    ...mapGetters(['chatRoomData'])
  },
  data() {
    return {
      toolbarHeaderStyle: {}
    };
  },
  mounted() {
    this.toolbarHeaderStyle = {
      'background-color':
        window.sessionStorage.getItem('HEADER_STYLE') && JSON.parse(window.sessionStorage.getItem('HEADER_STYLE')).toolbarBackgroundColor
    };
  }
};
</script>

<style lang="scss">
.notFound {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  dl {
    padding-top: 260px;
    padding-bottom: 5vh;
    max-width: 370px;
    width: 100%;
    text-align: center;
    background: url(https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/img_webchat_404.png) center top no-repeat;
    background-size: 80% auto;
    dt {
      padding-bottom: 10px;
      font-weight: bold;
      font-size: 24px;
      line-height: 33px;
    }
    dd {
      font-size: 14px;
      line-height: 19px;
      text-align: center;
    }
  }
}
</style>
